<template>
  <div class="card-deposit-money">
    <img class="img-new" :src="tagNew" />
    <div class="card-deposit-money__body">
      <div class="card-deposit-money__header">
        <img :src="logoPix" alt="Logo Pix" />
        <p>Adicione dinheiro na sua Carteira com o Pix</p>
      </div>

      <p class="card-deposit-money__content">
        Novidade! Agora você pode
        <strong>fazer um Pix direto para a sua Carteira do Casar.com</strong> e
        aproveitar todas as ofertas exclusivas do Shopping Casar.com
      </p>

      <button
        @click="$emit('open-modal-deposit-money', true)"
        type="button"
        class="button is-fullwidth is-flex margin-bottom is-support is-big"
      >
        Adicionar dinheiro na minha Carteira
      </button>

      <div class="card-deposit-money__footer">
        <a
          href="https://casarpontocom.freshdesk.com/support/solutions/articles/73000551985-como-comprar-no-shopping-se-n%C3%A3o-possuo-saldo-suficiente-"
          target="_blank"
          >Saiba mais <img :src="arrowRight"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import tagNew from '@/assets/img/tag-novo.png'
import logoPix from '@/assets/img/logo-pix.png'
import arrowRight from '@/assets/img/arrow-support.png'

export default {
  data() {
    return {
      tagNew,
      logoPix,
      arrowRight,
    }
  },
}
</script>

<style lang="scss" scoped>
.card-deposit-money {
  border-radius: 4px;
  position: relative;
  padding: 1.5em 1em;
  background-color: #fafcfd;
  max-width: 360px;
  margin: 24px auto;
  z-index: 29;

  &__body {
    max-width: 320px;
    margin: 0 auto;
  }

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 19px;
    margin-top: 12px;

    img {
      max-width: 42px;
    }

    p {
      font-family: Lato;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.14;
      color: #5b6674;
      padding-left: 16px;
    }
  }

  .button {
    @media (max-width: $mobile) {
      font-size: 17px;
    }
  }

  &__content {
    font-family: Lato;
    font-size: 14px;
    line-height: 1.43;
    color: #8493a2;
    margin-bottom: 21px;
    text-align: center;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    a {
      display: flex;
    }
  }
}

.img-new {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
